export default __webpack_public_path__ + "static/phone3-e78498714124d4161e1b445a6b68478c.jpg";